import { Button, Modal } from 'semantic-ui-react';
import React from 'react';
import WarningRed from 'Assets/images/commons/warning-red.svg';
import { bool, func, string } from 'prop-types';

import styles from './ErrorModal.less';

const ErrorModal = ({ open, onClose, errorMsg, title }) => {
  return (
    <Modal closeIcon onClose={onClose} open={open} size="tiny" closeOnDimmerClick={false}>
      <Modal.Content>
        <div className={styles.wrapPopup}>
          <img src={WarningRed} alt="warning" />
          {title && <div className={styles.warningTitle}>{title}</div>}
          <div className={styles.warningContent}>{errorMsg}</div>
        </div>
      </Modal.Content>
      <Modal.Actions className={styles.actionsWrapper}>
        <Button onClick={onClose}>Close</Button>
      </Modal.Actions>
    </Modal>
  );
};

ErrorModal.propTypes = {
  open: bool,
  onClose: func,
  errorMsg: string,
  title: string,
};

export default ErrorModal;
